const QuickAccessLinkItem = ({
    icon,
    title,
    description,
    index,
    isOnly,
    href,
    skipAnchor = false,
}) => {
    const borderClasses =
        isOnly === true
            ? 'border-none'
            : index === 0
              ? 'border-y border-neutral-300'
              : 'border-b border-neutral-300';

    const wrapperClasses = `group w-full ${borderClasses}`;

    const content = (
        <div className="flex flex-row gap-4 items-start p-4 group-hover:bg-neutral-100 group-hover:cursor-pointer group-hover:rounded-lg transition-all duration-500">
            <div className="text-primary group-hover:text-accent">{icon}</div>
            <div className="flex flex-col">
                <strong className="leading-relaxed ">{title}</strong>
                <p className="text-neutral-500">{description}</p>
            </div>
        </div>
    );

    return (
        <div className={wrapperClasses}>
            {href && !skipAnchor ? (
                <a href={href} target="_blank" rel="noreferrer" className="block">
                    {content}
                </a>
            ) : (
                content
            )}
        </div>
    );
};

export default QuickAccessLinkItem;
